var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomizedMenusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8854 9.9989C48.8828 8.60557 48.0345 7.72341 46.9134 8.07887C46.2078 8.30199 37.8998 13.8701 38.8702 33.8512C39.0284 35.9245 39.9289 37.3229 41.4726 38.3893C42.9878 39.4349 43.3873 40.7531 43.2396 42.5123C42.8918 46.6688 42.6532 48.3085 42.4196 52.4755C42.3028 54.5771 43.8518 56.1053 45.8809 55.9939C47.6348 55.8979 48.8828 54.4656 48.8854 52.4704C48.8958 44.8629 48.8958 14.5239 48.8854 9.9989Z",
    fill: "#26B8E3",
    stroke: "#383838",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1545 8.99707C31.3284 12.8916 31.5177 16.7836 31.6734 20.6781C31.7748 23.2001 30.9108 25.3692 29.0217 27.0428C26.4375 29.3286 25.8018 32.1438 26.1521 35.483C26.7956 41.6428 27.2678 45.2958 27.7062 51.4737C27.8828 53.9542 25.6539 55.9988 23.394 55.9988C21.1315 55.9988 18.9027 53.9542 19.0791 51.4737C19.5202 45.2958 19.9899 41.6428 20.6333 35.483C20.9836 32.1438 20.3479 29.3286 17.7637 27.0428C15.8748 25.3692 15.0108 23.2001 15.1119 20.6781C15.2676 16.7836 15.457 12.8916 15.6309 8.99707",
    stroke: "#383838",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3853 18.4426L23.4112 9.20312",
    stroke: "#383838",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizedMenusIcon);
export default __webpack_public_path__ + "static/media/CustomizedMenusIcon.b703eb477dcdfa0c156272d5cdb48b52.svg";
export { ForwardRef as ReactComponent };